import moment from 'moment';

const CUSTOM_LOCALE = 'es-PR';

export const date = (value, format = 'DD/MMM/YYYY') => {
  if (value == undefined || value == '') return '-';

  return moment(value)
    .locale(CUSTOM_LOCALE)
    .format(format)
    .replace(/ 0(?:0)?/, ' ');
};

export const hour = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .utcOffset('-0400')
    .format('hh:mm a');

  return result;
};

export const capitalize = (value) => {
  if (!value) return '';
  value = value.toString();

  return value
    .toLowerCase()
    .split(' ')
    .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1))
    .join(' ');
};

export const datetime = (value) => {
  if (value == undefined || value == '') return '-';

  let result = moment(value)
    .locale(CUSTOM_LOCALE)
    .utcOffset('-0400')
    .format('DD/MMM/YYYY hh:mm a');

  return result;
};

export const phone = (value) => {
  if (value == undefined || value == '') return '-';

  return value
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const appointment = (value) => {
  if (value == undefined || value == '') return '-';

  return value.replace(/[^0-9]/g, '').replace(/(\d{4})(\d{6})/, '$1-$2');
};

export const empty = (value) => {
  return !value ? '-' : value;
};

export const formatBoolean = (value) => {
  return value ? 'Si' : 'No';
};

export const price = (value) => {
  let val = (value / 1).toFixed(2);
  return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const ssn = (value) => {
  if (value == undefined || value == '') return '-';

  return value.replace(new RegExp('.{5}(?=.{4}$)'), '***-**-');
};

export const numberWithCommas = (value) => {
  if (value == undefined || value == '') return '-';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const toBoolean = (value) => {
  if (value == undefined || value == null) return null;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;

  const str = String(value)
    .toLowerCase()
    .trim();
  if (str == '') return null;
  return str === 'true' || str === '1';
};
